var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.643 18.554a1.267 1.267 0 00-1.792 0l-3.224 3.225-3.224-3.225a1.267 1.267 0 10-1.792 1.792l3.225 3.224-3.225 3.224a1.267 1.267 0 001.791 1.792l3.225-3.225 3.224 3.225a1.267 1.267 0 101.792-1.791l-3.225-3.225 3.225-3.224a1.267 1.267 0 000-1.792z"
  })));
}

export default SvgClose;